import styled from 'styled-components';

export const LoginContainer = styled.div`
  padding: 40px 0;
`;

export const Form = styled.form`
  width: 100%;
  background-color: #fff;
  padding: 20px;
  border-radius: 25px;
`;

export const Flex = styled.div`
  @media (min-width: 64.5em) {
    min-height: calc(100vh - 180px);
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center; 
  }
`;

export const Options = styled.div`
  a{
    text-decoration: none;
  }
`;

export const FormDiv = styled.div`
  max-width: 600px;
  margin: 0 auto;

  @media (min-width: 64.5em) {
    width: 100%;
    padding: 0 20px;        
    max-height: 100vh;
    overflow: auto;
    
    &::-webkit-scrollbar {
        background-color: #fff;
        width: 16px;
    }

    /* background of the scrollbar except button or resizer */
    &::-webkit-scrollbar-track {
        background-color: #fff;
    }

    /* scrollbar itself */
    &::-webkit-scrollbar-thumb {
        background-color: #babac0;
        border-radius: 16px;
        border: 4px solid #fff;
    }

    /* set button(top and bottom of the scrollbar) */
    &::-webkit-scrollbar-button {
        display:none;
    }
  }
`;

export const Buttons = styled.div`
  display: flex;
  
  button{
    margin: 10px 20px 0 0;
  }
`;

export const Submit = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
`;


export const Transportadora = styled.div`
  padding: 20px 0;

  input{
    background-color: #fff;
  }

  button{
    margin-left: 10px;
  }
`;